import './Theme1.css';

import React, { useState } from 'react';

import { AndimarTitle } from '../common/Title/AndimarTitle';
import ContactForm4 from '../common/contact/ContactForm4';
import { HomeBanners } from '..';
import MultiSlider3 from '../common/MultiSlider/MultiSlider3';
import SearchBox3 from '../common/search-box/SearchBox3';
import StartPopup from '../common/popup/StartPopup';
import ZoomSlider from '../common/ZoomSlider/ZoomSlider';
import contactBy1 from '../assets/andimar/contact-by/contact.svg';
import contactBy2 from '../assets/andimar/contact-by/email.svg';
import contactBy3 from '../assets/andimar/contact-by/location.svg';
import getIcons from '../functions/getIcons/getIcons';
import getSlides from '../functions/getSlides/getSlides';
import socialMedia1 from '../assets/andimar/social-media/fb.png';
import socialMedia2 from '../assets/andimar/social-media/insta.png';
import takeCare1 from '../assets/andimar/take-care/icons-1.svg';
import takeCare2 from '../assets/andimar/take-care/icons-2.svg';
import takeCare3 from '../assets/andimar/take-care/icons-3.svg';
import takeCare4 from '../assets/andimar/take-care/icons-4.svg';
import takeCare5 from '../assets/andimar/take-care/icons-4.svg';
import takeCare6 from '../assets/andimar/take-care/icons-4.svg';
import takeCare7 from '../assets/andimar/take-care/icons-4.svg';

const styles = {
	searchBoxOverlay: {
		position: 'absolute',
		width: '50%',
		top: '30vh',
		zIndex: 10,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
};

let contactByArr = [
	{
		text: '(+562) 2683 8528 // (+56 9) 4915 6683',
		image: '/assets/andimar/social-media/whatsapp.png',
	},
	{
		text: 'ayuda@pasajebus.com',
		image: contactBy2,
	},
	{
		text: `Compañía 4368 - Quinta Normal.
    Santiago, Región Metropolitana.`,
		image: contactBy3,
	},
];

const socialMedia = [
	{
		icon: socialMedia1,
		link: 'https://www.facebook.com/NuevaAndimarVIP',
	},
	{
		icon: socialMedia2,
		link:
			'https://www.instagram.com/andimarvip/?utm_source=ig_embed&ig_mid=327903A9-8631-4919-BB95-D5083ADB2AAD&hl=es',
	},
];

const takeCareIcons = [
	// {
	//   text: (
	//     <span>
	//       <strong>Uso obligatorio de mascarilla.</strong>
	//       <br />
	//       ¡Lleva siempre contigo tu <br />
	//       alcohol gel!
	//     </span>
	//   ),
	//   image: '/assets/andimar/take-care/icons-1.svg',
	// },
	{
		text: (
			<span>
				Limpieza
				{/* Contamos con
        <br /> <strong>buses sanitizados.</strong> */}
			</span>
		),
		image: '/assets/andimar/take-care/icons-2.svg',
	},
	// {
	//   text: (
	//     <span>
	//       No olvides tu <strong>pasaporte</strong> <br /> <strong>sanitario</strong> y de ser
	//       necesario,
	//       <br /> un <strong>salvoconducto</strong>
	//     </span>
	//   ),
	//   image: '/assets/andimar/take-care/icons-3.svg',
	// },
	// {
	//   text: (
	//     <span>
	//       Mantén el
	//       <br /> <strong>distanciamiento social.</strong>
	//     </span>
	//   ),
	//   image: '/assets/andimar/take-care/icons-4.svg',
	// },
	{
		text: <span>Audífonos</span>,
		image: '/assets/andimar/take-care/icons-5.svg',
	},
	{
		text: <span>USB</span>,
		image: '/assets/andimar/take-care/icons-6.svg',
	},
	{
		text: <span>Puntualidad</span>,
		image: '/assets/andimar/take-care/icons-7.svg',
	},
];

function Theme1({ history, operator, actions }) {
	const [showPopup, setShowPopup] = useState(true);

	// contactByArr[0].text = operator && operator.phone_number 
	contactByArr[1].text = operator && operator.email

	return (
		<div style={{ overflowX: 'hidden' }} className="montserrat">
			{/* <StartPopup
        showPopup={showPopup}
        setShowpop={setShowPopup}
        imageSource={getIcons('Popup', operator)}
      /> */}
			<div style={{ position: 'relative' }}>
				<HomeBanners
					slides={getSlides('Banner', operator)}
					height={'98vh'}
					activeDotColor={operator && operator.color_codes && operator.color_codes.button_color}
				/>

				<div className="searchBoxOverlay">
					<div className="new-container">
						<SearchBox3 history={history} operator={operator} />
					</div>
				</div>
			</div>
			<div className="new-container">
				<div style={{ marginTop: 70 }}>
					<AndimarTitle title={'NUESTROS DESTINOS FAVORITOS'} />
				</div>

				<div style={{ marginTop: -20 }}>
					<MultiSlider3
						multiSlides={getSlides('Destination', operator)}
						removeArrowOnDeviceType={[]}
						andrimarArrowStyle
						operator={operator}
					/>
				</div>

				<AndimarTitle title={'EXTRAS EN EL SERVICIO'} />

				<div className="light-blue-background"></div>
				<div className="take-care d-flex " style={{ justifyContent: 'space-around' }}>
					{takeCareIcons.map(item => (
						<div
							className="take-care-item d-flex flex-column align-items-center text-center"
							style={{ width: '25%' }}
						>
							<img src={item.image} alt="" />
							<p className="mt-2">{item.text}</p>
						</div>
					))}
				</div>

				<div className="contact-us d-flex my-5 ">
					<ContactForm4 operator={operator} actions={actions} />
					<div className="contact-by w-50 d-flex justify-center align-items-start flex-column ">
						{contactByArr.map(item => (
							<div className="contact-by-item d-flex ">
								<img src={item.image} alt="" style={{ width: '40px' }} />
								<span className="lh-1-3" style={{ fontWeight: 'bold', fontSize: '13px' }}>
									{item.text}
								</span>
							</div>
						))}
						<div className="social-media">
							<div
								style={{
									color: operator.theme_color2 && operator.theme_color2,
									marginBottom: 10,
									fontWeight: 'bold',
									fontSize: '16px',
								}}
							>
								SÍGUENOS EN REDES SOCIALES
							</div>
							<div>
								{socialMedia.map(item => (
									<a href={item.link} target="_blank">
										<img src={item.icon} alt="" />
									</a>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Theme1;



// WEBPACK FOOTER //
// ./src/features/themes/themes1/Theme1.js